<div
  class="hot-toast-checkmark-icon"
  [style.--check-primary]="theme?.primary"
  [style.--check-secondary]="theme?.secondary"
></div>
